// WaitingRoom.jsx
// Shown to the patient after they enter the lobby and are waiting for the doctor.

import { formatDistanceToNow } from "date-fns";

export default function WaitingRoom({ session, onLeave }) {
  const apptTime = session?.appointmentTime
    ? new Date(session.appointmentTime).toLocaleString("en-US", {
        weekday: "short", month: "short", day: "numeric",
        hour: "2-digit", minute: "2-digit",
      })
    : null;

  return (
    <div className="page-center waiting-bg">
      <div className="waiting-card">

        {/* Header */}
        <div className="waiting-header">
          <div className="waiting-logo">
            KSM <span>CareLink</span>
          </div>
        </div>

        {/* Avatar + pulse */}
        <div className="waiting-avatar-wrap" aria-hidden="true">
          <div className="pulse-ring pulse-ring-1" />
          <div className="pulse-ring pulse-ring-2" />
          <div className="waiting-avatar">👨‍⚕️</div>
        </div>

        {/* Status */}
        <h2 className="waiting-title">You're in the waiting room</h2>

        {session && (
          <p className="waiting-doctor">
            <strong>Dr. {session.doctorName}</strong> will be with you shortly.
          </p>
        )}

        {apptTime && (
          <div className="waiting-appt-chip">
            <span className="chip-icon" aria-hidden="true">🗓</span>
            {apptTime}
          </div>
        )}

        {/* Live status indicator */}
        <div className="waiting-status-row" role="status" aria-live="polite">
          <span className="status-dot" aria-hidden="true" />
          <span>Checking for your doctor…</span>
        </div>

        {/* Tips */}
        <ul className="waiting-tips" aria-label="Tips before your visit">
          <li>
            <span aria-hidden="true">🎤</span>
            Camera and microphone will activate when the visit begins
          </li>
          <li>
            <span aria-hidden="true">🔇</span>
            Find a quiet, well-lit spot if you haven't already
          </li>
          <li>
            <span aria-hidden="true">🖥</span>
            Keep this tab open — do not close or refresh the page
          </li>
        </ul>

        <button className="btn btn-ghost" onClick={onLeave}>
          Leave waiting room
        </button>
      </div>
    </div>
  );
}
